import { Backdrop, CircularProgress, Container, Grid, TextField } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Success from '../../../components/Form/Success';
import PageTitle from '../../../components/ui/PageTitleUI';
import { useAuth } from '../../../hooks/auth';
import { ConciergeSearch } from '../../../interfaces/Concierge';
import { MvmExit } from "../../../interfaces/Mvm";
import MvmStatus from '../../../interfaces/MvmStatus';
import MvmApi from '../../../services/MvmApi';
import permissions from '../../../utils/Permissions';
import MvmFooter from '../components/MvmFooter';
import MvmSummary from '../components/MvmSummary';
import { useStyles } from '../Style';
import MvmGeneralInfo from '../components/MvmGeneralInfo';
import MvmCompositionPartInfo from '../components/MvmCompositionPartInfo';

interface IFormInput {
    mvmNumber: any;
    invoices: any;
    name: string;
    rg: string;
    cpf: string;
    cnh: string;
    ajudantes: string;
    concierge: any;
    conciergeCode: string;
    mvmNumberCart: string;
    vehiclePlateNumberCart: string;
}


const opcoes = [
    { url: '/Checkout', descricao: 'Registrar Nova Saída', state: {}},
]

const CheckInOut: React.FC = () => {
    const classes = useStyles()
    const { user, hasPermission } = useAuth()
    const history = useHistory();
    const { t: _t } = useTranslation("General");
    const { t: tMvm } = useTranslation("Mvm");
    const { t } = useTranslation("Checkout");
    const { enqueueSnackbar } = useSnackbar();
    const [circularLoading, setCircularLoading] = useState(false)
    const [loading, setLoading] = useState(true);
    const [concierges, setConcierges] = useState<any>([]);
    const [mvm, setMvm] = useState<any>(null);
    const [cartMvmEntrance, setCartMvmEntrance] = useState<any>(null)
    const [cartMvmExit, setCartMvmExit] = useState<any>(null)
    const [conciergeCode, setConciergeCode] = useState<string>('');
    const [concierge, setConcierge] = useState<any>({code: '', label: ''});
    const [success, setSuccess] = useState(false);
    const { control, setValue, getValues } = useForm<IFormInput>(
        {
            defaultValues: { mvmNumber: {}, conciergeCode: '', concierge: {} }
        })
    
    const onSummaryChange = (data: any) => {
        if (!data) {
            setMvm(null);
            setCartMvmExit(null)
            setCartMvmEntrance(null)
            return
        }

        setMvm(data);
        setCompositionInfo(data.mvmType, data.compositions)
        setValue("invoices", data.invoices);
    }

    const setCompositionInfo = (mvmType : string, compositions : any[]) => {
        if (compositions.length === 0 || mvmType === "C") 
            return 

        var cartEntrance = compositions.filter((f : any) => f.movementType == "EN")[0]?.cartMvm
        var cartExit = compositions.filter((f : any) => f.movementType == "EX")[0]?.cartMvm

        if (cartEntrance)
            setCartMvmEntrance(cartEntrance)
        
        if (cartExit)
            setCartMvmExit(cartExit)
    }

    const getConcierges = useCallback(
        async (data: ConciergeSearch) => {               
            setLoading(true);

            MvmApi.searchConcierge(data)
                .then(result => {
                    if (result && result.items) {
                        setConcierges(result.items);}
                    else {
                        setConcierges([]);
                    }
                }).catch(() => {
                    setConcierges([]);
                }).finally(() => {
                    setLoading(false);
                });
        },
        [],
    );

    useEffect(() => {
        MvmApi.getUserConcierge(user.userName, +user.company.plantID).then(conci => {
            setConciergeCode(conci.code);
            setConcierge({code: conci.code, label: conci.code});
            setValue("concierge", {code: conci.code, label: conci.code});
            setValue("conciergeCode", conci.code);

        });
    }, [concierges])

    useEffect(() => {
        if (!hasPermission(permissions.MVM.RegisterExit))
            history.replace('NoPermission');
    }, [history, user])

    useEffect(() => {

        let conciergeFilter:ConciergeSearch = {
            id:0,
            code: "",
            plantId: Number(user.company.plantID),
            deleted: false,
            pageSize: 999
        };

        getConcierges(conciergeFilter);
    },[]);

    async function CheckOut()
    {
        if (mvm.mvmType === 'C') {
            enqueueSnackbar(tMvm("mvmCartCannotEnterExit"), { variant: 'warning' })
            return
        }
        
        setCircularLoading(true);

        const mvmExit: MvmExit = {
            id: mvm.id,
            companyCode: mvm.companyCode,
        };

        MvmApi.exitMvm(mvmExit)
        .then(() => {
            enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' });
            setSuccess(true);
        })
        .finally(() => { setCircularLoading(false); });
    }
   
    if (success)
    return (
        <Container maxWidth={false} component="main">
            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <Success opcoes={opcoes}/>
                </div>
            </div>
        </Container>
    )
    else   
    return (
        <Container maxWidth={false} component="main">

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
           
            <PageTitle title={t("registered exit") + (mvm ? " - " + mvm.mvmNumber:"")} />
            <form translate={undefined} >
            <div className={classes.rootContent}>
                            
            <MvmSummary
                control={control}
                name={"summary"}
                onChange={onSummaryChange}
                setValue={setValue}
                showAutoComplete={false}
                mvmStatus={[
                        MvmStatus.FLAG_STATUS_PENDING_UNLOAD, 
                        MvmStatus.FLAG_STATUS_PENDING_FINISH_UNLOAD,
                        MvmStatus.FLAG_STATUS_PENDING_LOAD,
                        MvmStatus.FLAG_STATUS_PENDING_TRANSPORT_ORDER,
                        MvmStatus.FLAG_STATUS_PENDING_INVOICING,
                        MvmStatus.FLAG_STATUS_PENDING_EXIT]}
                includeProperties={["Invoices", "Compositions"]}
            />
            </div>

            {mvm && mvm.mvmType !== "C" && (mvm.composition || mvm.compositions.length > 0) &&
                <>
                    <div className={classes.rootContent}>
                        <MvmCompositionPartInfo 
                            mvm={cartMvmEntrance}
                            control={control}
                            setValue={setValue}
                            type={tMvm('cart')}
                            movementType={tMvm('entrance')} />
                    </div>
                    
                    <div className={classes.rootContent}>
                        <MvmCompositionPartInfo 
                            mvm={cartMvmExit}
                            control={control}
                            setValue={setValue}
                            type={tMvm('cart')}
                            movementType={tMvm('exit')} />
                    </div>
                </>
            }

            {loading || mvm == null ? <></> :
            <>
                <MvmFooter
                    control={control}
                    name={"footer"}
                    onChange={onSummaryChange}
                    setValue={setValue}
                    checkInOrOut={CheckOut}
                    pngValidated={mvm.pngValidated}
                    conciergeReleaseDate={mvm.conciergeReleaseDate}
                    status={mvm.status}
                    concierges={concierges}
                    mvmType={mvm.mvmType}
                    // mvmStatus={
                    //     [MvmStatus.FLAG_STATUS_PENDING_UNLOAD,
                    //       MvmStatus.FLAG_STATUS_PENDING_FINISH_UNLOAD,
                    //       MvmStatus.FLAG_STATUS_PENDING_LOAD ,
                    //       MvmStatus.FLAG_STATUS_PENDING_TRANSPORT_ORDER ,
                    //       MvmStatus.FLAG_STATUS_PENDING_INVOICING ,
                    //       MvmStatus.FLAG_STATUS_PENDING_EXIT]
                    // }
                    />
            </>}

            </form>
        </Container>
    )
}
export default CheckInOut;